import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=af1ee14a&scoped=true"
import script from "./ItemSelector.vue?vue&type=script&lang=js"
export * from "./ItemSelector.vue?vue&type=script&lang=js"
import style0 from "./ItemSelector.vue?vue&type=style&index=0&id=af1ee14a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1ee14a",
  null
  
)

export default component.exports